import React from "react";
import Boton1 from '../Componentes/boton';
import { FaCode, FaFolderOpen, FaUserCircle } from "react-icons/fa";
import "./menu.css";

const proyectos = () => {
  window.location.href = "/proyectos";
};

const conoceme = () => {
  window.location.href = "/sobremi";
};

const homeLink = () => {
  window.location.href = "/";
};

const layout = ({ children }) => {
  return (
    <>
      <div className="header">
        <span className="span1Header" onClick={homeLink}>
          <FaCode className="iconDev" />
          JUAN CAMILO MUÑOZ
        </span>

        <div className="botonesContainer">
          <span className="proyectosLink" onClick={conoceme}>
            <FaUserCircle className="iconProyectos" />
            Conóceme
          </span>
          <span className="proyectosLink" onClick={proyectos}>
            <FaFolderOpen className="iconProyectos" />
            Proyectos
          </span>
          <Boton1 />
        </div>
      </div>
      {children}
    </>
  );
};

export default layout;
